import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
// @ts-expect-error file not migrated yet
import propertyValueToNumber from 'customer-data-sidebar/universal/dataAccessHelpers/propertyValueToNumber';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ProbabilityBar from './ProbabilityBar';
import { getPropertyValueFromProperties } from '../../../../helpers/propertiesHelpers';
import { useAccessLevel } from 'customer-data-properties/accessLevel/AccessLevelContext';
import AutosaveChickletStageSelect from '../../../../chicklets/AutosaveChickletStageSelect';
import emptyFunction from 'react-utils/emptyFunction';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { DISPLAY_LABEL_FALLBACK } from '../../../../constants/displayLabelFallback';
import { GET_SPECIFIC_PIPELINE } from '../../../../dfc-queries';
import { useQuery } from 'data-fetching-client';
import { getUserCanEditAssociation } from '../../../../helpers/migrationHelpers';
import { SecondaryPropertyLabel } from '../../../../card/secondaryProperties/SecondaryPropertyDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const emptyFunctionThatReturnsUndefined = emptyFunction.thatReturns(undefined);
const currencyProps = {
  simplifyCurrency: false
};
const useGetDealChickletSecondaryDisplayLabels = ({
  properties,
  object,
  toObjectTypeId,
  readOnly,
  objectId
}) => {
  var _pipelineData$specifi;
  const closeDate = propertyValueToNumber(getPropertyValueFromProperties(properties, 'closedate'));
  const amount = propertyValueToNumber(getPropertyValueFromProperties(properties, 'amount'));
  const currentStageId = getPropertyValueFromProperties(properties, 'dealstage');
  const pipelineId = getPropertyValueFromProperties(properties, 'pipeline');
  const {
    data: pipelineData
  } = useQuery(GET_SPECIFIC_PIPELINE, {
    variables: {
      objectTypeId: toObjectTypeId,
      pipelineId: pipelineId || ''
    },
    skip: !pipelineId
  });
  const probabilityStages = pipelineData === null || pipelineData === void 0 || (_pipelineData$specifi = pipelineData.specificPipeline) === null || _pipelineData$specifi === void 0 ? void 0 : _pipelineData$specifi.stages;
  const probabilityCurrentStage = probabilityStages === null || probabilityStages === void 0 ? void 0 : probabilityStages.find(stage => stage.stageId === currentStageId);
  const dealstageAccessLevel = useAccessLevel({
    objectType: toObjectTypeId,
    propertyName: 'dealstage'
  });
  const getSavedValue = propertyName => {
    return getPropertyValueFromProperties(properties, propertyName);
  };
  const canEdit = getUserCanEditAssociation(object);
  const renderStageSection = propertyDefinition => {
    const label = /*#__PURE__*/_jsx(Flex, {
      flexShrink: 0,
      children: /*#__PURE__*/_jsx(SecondaryPropertyLabel, {
        propertyLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardAssociatedObjects.chicklet.DealChickletSecondaryPropertyLabels.stage"
        })
      })
    });
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        "data-selenium-test": "deal-chicklet-stage-select",
        "data-test-id": "deal-chicklet-stage-select",
        children: [label, /*#__PURE__*/_jsx(Box, {
          minInlineSize: "0",
          children: /*#__PURE__*/_jsx(AutosaveChickletStageSelect, {
            value: currentStageId,
            objectTypeId: toObjectTypeId,
            objectId: objectId,
            stagePropertyDefinition: propertyDefinition,
            readOnly: readOnly || !canEdit,
            fieldLevelAccess: dealstageAccessLevel,
            getSavedValue: getSavedValue,
            getDraftValue: emptyFunctionThatReturnsUndefined
          })
        })]
      }), probabilityStages && probabilityCurrentStage && /*#__PURE__*/_jsx(ProbabilityBar, {
        currentStage: probabilityCurrentStage,
        stages: probabilityStages
      })]
    });
  };
  const renderCloseDate = () => {
    const dateText = closeDate ? /*#__PURE__*/_jsx(FormattedDateTime, {
      value: closeDate,
      type: "userTz",
      format: "LL"
    }) : DISPLAY_LABEL_FALLBACK;
    return /*#__PURE__*/_jsxs("div", {
      "data-selenium-test": "deal-chicklet-close-date",
      "data-test-id": "deal-chicklet-close-date",
      children: [/*#__PURE__*/_jsx(SecondaryPropertyLabel, {
        propertyLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardAssociatedObjects.chicklet.DealChickletSecondaryPropertyLabels.closeDate"
        })
      }), dateText]
    });
  };
  const renderCurrency = propertyDefinition => /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(SecondaryPropertyLabel, {
      propertyLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardAssociatedObjects.chicklet.DealChickletSecondaryPropertyLabels.amount"
      })
    }), /*#__PURE__*/_jsx(FormattedPropertyV2, {
      objectTypeId: toObjectTypeId,
      objectId: `${objectId}`,
      value: amount === null || amount === undefined ? amount : `${amount}`,
      getDraftValue: emptyFunctionThatReturnsUndefined,
      getSavedValue: getSavedValue,
      currencyProps: currencyProps
      // @ts-expect-error Known property issue as they have not updated the type definitions
      // https://hubspot.slack.com/archives/C025K57CMMG/p1696524684019289?thread_ts=1696349045.450059&cid=C025K57CMMG
      ,
      property: propertyDefinition
    })]
  });
  const propertyFormatters = {
    dealstage: renderStageSection,
    closedate: renderCloseDate,
    amount: renderCurrency
  };
  return {
    propertyFormatters,
    copyDisabled: true
  };
};
export default useGetDealChickletSecondaryDisplayLabels;